module.exports = __webpack_public_path__ + "static/media/sell_finish_service_make_5.f037ac44.jpg";